'use strict';

const HomeyAPIV3 = require('./HomeyAPIV3');
const ManagerFlow = require('./HomeyAPIV2/ManagerFlow');
const ManagerFlowToken = require('./HomeyAPIV2/ManagerFlowToken');
const ManagerDevices = require('./HomeyAPIV2/ManagerDevices');
const ManagerDrivers = require('./HomeyAPIV2/ManagerDrivers');
const ManagerDevkit = require('./HomeyAPIV2/ManagerDevkit');
const ManagerInsights = require('./HomeyAPIV2/ManagerInsights');

/**
 * This class is returned by {@link AthomCloudAPI.Homey#authenticate} for a Homey with `platform: 'local'` and `platformVersion: 1`.
 *
 * @class
 * @hideconstructor
 * @extends HomeyAPIV3
 */
class HomeyAPIV2 extends HomeyAPIV3 {

  static DEFAULT_TIMEOUT = 1000 * 30;

  static MANAGERS = {
    ...super.MANAGERS,
    ManagerFlow,
    ManagerFlowToken,
    ManagerDevices,
    ManagerDrivers,
    ManagerDevkit,
    ManagerInsights,
  };

  get platform() {
    return 'local';
  }

  get platformVersion() {
    return 1;
  }

}

module.exports = HomeyAPIV2;
